import React from 'react';
export function Footer() {
  return <footer className="bg-forest-deep text-sage-mist py-12 text-center text-sm border-t border-moss/20" data-id="element-270">
      <div className="max-w-4xl mx-auto px-4 space-y-2" data-id="element-271">
        <p className="font-serif font-bold text-cream-warm text-lg" data-id="element-272">
          🌿 HOGAR NATURAL™
        </p>
        <p className="opacity-80" data-id="element-273">
          © 2025 Hogar Natural. Todos los derechos reservados.
        </p>
        <p className="text-xs opacity-60 max-w-2xl mx-auto mt-6" data-id="element-274">
          Este producto es educativo e informativo. No reemplaza la consulta
          médica profesional.
        </p>
      </div>
    </footer>;
}